import { ERROR, PRIMARY_GRAY, VALIDATION } from 'styles/Colors';
import ErrorCross from 'components/display/ErrorCross';
import LineSvg from 'images/Line.svg';
import React from 'react';
import SuccessCheckmark from 'components/display/SuccessCheckmark';

const titleStyle = {
  marginTop: '1.5rem',
  marginLeft: '1rem'
};

const ruleContainerStyle = {
  alignItems: 'center',
  display: 'flex'
};

const ruleIconStyle = {
  alignItems: 'center',
  display: 'flex',
  height: '2rem',
  justifyContent: 'center',
  width: '2.8rem'
};

const iconStyle = {
  width: '2.8rem'
};

const ruleTextStyle = {
  paddingLeft: '0.5rem'
};

const untouchedRuleStyle = {
  color: PRIMARY_GRAY
};

const passedRuleStyle = {
  color: VALIDATION
};

const failedRuleStyle = {
  color: ERROR
};

function RuleContainer({ colorStyle, IconComponent, text }) {
  return (
    <div css={ruleContainerStyle}>
      <div css={ruleIconStyle}>
        <IconComponent overrideSvgStyle={iconStyle} />
      </div>

      <p css={[ruleTextStyle, colorStyle]}>{text}</p>
    </div>
  );
}

function PasswordRule({ status, text }) {
  let colorStyle = passedRuleStyle;
  let IconComponent = SuccessCheckmark;

  if (status === 'unTouch') {
    colorStyle = untouchedRuleStyle;
    IconComponent = LineSvg;
  } else if (status === 'fail') {
    colorStyle = failedRuleStyle;
    IconComponent = ErrorCross;
  }

  return (
    <RuleContainer
      colorStyle={colorStyle}
      IconComponent={IconComponent}
      text={text}
    />
  );
}

function PasswordRequirements({ rules = [] }) {
  return (
    <>
      <p css={titleStyle}>Password Requirements</p>

      {rules.map((rule) => (
        <PasswordRule key={rule.text} status={rule.status} text={rule.text} />
      ))}
    </>
  );
}

export default PasswordRequirements;
